module.exports = "pegasus/assets/luna.png";